"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListCalendarsReplySchema = exports.CalendarSchema = exports.ListCalendarEventsRequestSchema = exports.ListCalendarEventsReplySchema = exports.AddCalendarEventReplySchema = exports.AddCalendarEventRequestSchema = exports.AddCalendarEventsReplySchema = exports.AddCalendarEventsRequestSchema = exports.ParamsCalendarIdSchema = exports.AddCalendarReplySchema = exports.AddCalendarRequestSchema = exports.CalendarEventSchema = exports.CalendarEventRequestSchema = exports.CalendarStatus = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../../core");
var CalendarStatus;
(function (CalendarStatus) {
    CalendarStatus["ACTIVE"] = "A";
    CalendarStatus["DELETED"] = "D";
})(CalendarStatus = exports.CalendarStatus || (exports.CalendarStatus = {}));
const calendarEventFields = {
    name: typebox_1.Type.String(),
    start: typebox_1.Type.Number(),
    end: typebox_1.Type.Number(),
    location: typebox_1.Type.Array(typebox_1.Type.String()),
};
exports.CalendarEventRequestSchema = (0, core_1.StrictObject)({
    ...calendarEventFields,
});
exports.CalendarEventSchema = (0, core_1.StrictObject)({
    id: typebox_1.Type.Number(),
    ...calendarEventFields,
});
exports.AddCalendarRequestSchema = (0, core_1.StrictObject)({
    name: typebox_1.Type.String(),
});
exports.AddCalendarReplySchema = (0, core_1.StrictObject)({
    id: typebox_1.Type.Number(),
    name: typebox_1.Type.String(),
});
exports.ParamsCalendarIdSchema = (0, core_1.StrictObject)({
    calendarId: typebox_1.Type.Number(),
});
exports.AddCalendarEventsRequestSchema = (0, core_1.StrictObject)({
    events: typebox_1.Type.Array(exports.CalendarEventRequestSchema),
});
exports.AddCalendarEventsReplySchema = (0, core_1.StrictObject)({
    count: typebox_1.Type.Number(),
});
exports.AddCalendarEventRequestSchema = (0, core_1.StrictObject)({
    calendar: typebox_1.Type.Object({
        name: typebox_1.Type.String(),
    }),
    data: typebox_1.Type.String({
        title: "ICS Data",
        description: "This must be ICS formatted data",
    }),
});
exports.AddCalendarEventReplySchema = (0, core_1.StrictObject)({
    name: typebox_1.Type.String(),
    id: typebox_1.Type.Number(),
    events: typebox_1.Type.Array(exports.CalendarEventSchema),
});
exports.ListCalendarEventsReplySchema = (0, core_1.StrictObject)({
    events: typebox_1.Type.Array(exports.CalendarEventSchema),
});
exports.ListCalendarEventsRequestSchema = (0, core_1.StrictObject)({
    id: typebox_1.Type.Number(),
});
exports.CalendarSchema = (0, core_1.StrictObject)({
    id: typebox_1.Type.Number(),
    name: typebox_1.Type.String(),
});
exports.ListCalendarsReplySchema = (0, core_1.StrictObject)({
    calendars: typebox_1.Type.Array(exports.CalendarSchema),
});
